<template>
    <div class="select"> 
        <div class="form__label">{{ title }}</div>
        <div class="form__item select">
        <select class="select__input select__input--sm" @change="onSelected">
            <option v-for="option in options" :value="option.value" :key="option.value">{{ option.name }}</option>
        </select>
        <div class="select__icon select__icon--sm">
            <svg height="10" viewBox="0 0 6 10" width="6" xmlns="http://www.w3.org/2000/svg">
                <path d="M6.03 3.03L3.025.025.02 3.03h6.01zM5.88 7.071L2.975 9.975.07 7.07H5.88z" fill="#637381" fill-rule="evenodd" />
            </svg>
        </div>
    </div>

  </div>
</template>
<script>
export default {
    name: 'Select',
    props: {
        title: String,
        options: Array,
        onSelected: Function
    }
}
</script>
<style lang="scss" scoped>
  .select {
    display: flex;
    flex-direction: column;
    max-width: 200px;

    .form__label {
      padding-left: 14px;
    }

    .select__input--sm  {
        padding: 8px 20px
    }
  }
</style>